var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "frame" }, [
    _c("iframe", {
      staticClass: "iframe",
      attrs: { src: _vm.activity.resource, frameBorder: "0" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }